<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${resellerInvoice.code}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="resellerInvoice" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "resellerInvoice-view-logs",

  components: { LogListTable },

  props: ["resellerInvoice"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
